import InfiniteLoading from "v3-infinite-loading";
import "v3-infinite-loading/lib/style.css";
const infinite = {
  install: (app) => {
    app.component("infinite-loading", InfiniteLoading);
  }
};
export {
  infinite as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5maW5pdGUtbG9hZGluZy5qcyIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3BsdWdpbnMvYmFuemEvaW5maW5pdGUtbG9hZGluZy5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgSW5maW5pdGVMb2FkaW5nIGZyb20gXCJ2My1pbmZpbml0ZS1sb2FkaW5nXCI7XG5pbXBvcnQgXCJ2My1pbmZpbml0ZS1sb2FkaW5nL2xpYi9zdHlsZS5jc3NcIjtcblxuZXhwb3J0IGRlZmF1bHQge1xuICBpbnN0YWxsOiAoYXBwKSA9PiB7XG4gICAgYXBwLmNvbXBvbmVudChcImluZmluaXRlLWxvYWRpbmdcIiwgSW5maW5pdGVMb2FkaW5nKTtcbiAgfSxcbn07XG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFHQSxNQUFlLFdBQUE7QUFBQSxFQUNiLFNBQVMsQ0FBQyxRQUFRO0FBQ2hCLFFBQUksVUFBVSxvQkFBb0IsZUFBZTtBQUFBLEVBQ2xEO0FBQ0g7In0=
